var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GridVx',{ref:"dailyPriceTable",attrs:{"columns":_vm.daysTableColumns,"auto-size-cell":true,"context":_vm.context,"rows":_vm.tableData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }